import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const StatTicker = ({ value, label, delay = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!inView) return;
    const match = String(value).match(/^([^\d]*)(\d+(?:\.\d+)?)(.*)$/);
    if (!match) return setDisplay(value);
    const [, prefix, num, suffix] = match;
    const target = parseFloat(num);
    const decimals = num.includes(".") ? num.split(".")[1].length : 0;
    const started = performance.now();
    const duration = 1400;
    let frame;
    const tick = (now) => {
      const p = Math.min((now - started) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const current = p === 1 ? num : (target * eased).toFixed(decimals);
      setDisplay(`${prefix}${current}${suffix}`);
      if (p < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, value]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay }}
      className="border-t border-zinc-800 pt-5"
      data-testid={`stat-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      <p className="font-display text-4xl font-bold leading-none tracking-tight text-white md:text-6xl">{display}</p>
      <p className="mt-3 text-xs uppercase tracking-[0.16em] text-zinc-500">{label}</p>
    </motion.div>
  );
};
